// 导入工具函数
import { getMemInfo } from './common';
// 导入消息提示对象
import { Toast } from 'vant';
// 导入axios
import axios from 'axios';
// 全局配置数据接口基础域名
// axios.defaults.baseURL = 'https://hpsw.dev.bjwellman.com/api';
axios.defaults.baseURL = 'https://saas.hykerp.com/api';
// axios.defaults.baseURL = 'http://2vhihi2exu.tcp01.cn';
// axios.defaults.baseURL='/api';
// 请求拦截器
// request: 系统自动注入的请求对象
axios.interceptors.request.use(function(request) {
    //  通过自定义请求头authorization将登录凭证传递给数据接口进行登录身份认证
    const memInfo = getMemInfo();
    request.headers.authorization = memInfo.token;
    // 必须返回请求对象
    return request;
});
// 响应拦截器
axios.interceptors.response.use(response => {
    // 登录过期
    if (response.data.code === 403) {
        // 提示消息
        Toast(response.data.msg);
        // 自动跳转到登录页面
        location.href = '#/login';
    }
    // 将数据接口返回的真实数据返回
    return response.data;
});
// 导出axios
export default axios;